import React, {Component} from 'react';
import {  Switch, Link, Route } from 'react-router-dom';
import ProjectListContent from '../components/ProjectListContent'; 
import axios from 'axios';
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import withRouter from '../components/withRouter';
import PageHeader from '../components/PageHeader'; 
import {api_base_url} from '../common/Constants'; 
 
class ProjectList extends React.Component{

    constructor(props){
        super(props);

        
        this.state = { 
            loading:1,
            type:[]
        }
    }

    componentDidMount()
    {
        var data = { id : this.props.params.id} 
            axios.post(api_base_url+"project_type", data).then(response=>{
                this.setState({type:response.data}); 
                this.setState({loading:0});
            }); 
    }
 
    render()
    {
       
        return (
            <div className="page-wrapper">
                <Header/> 
                <PageHeader title="Project List"/>
                <ProjectListContent slug={this.props.params.id}  title={this.state.type.title} />  
                <Footer/>
            </div>
       
        )
    }

}
export default withRouter(ProjectList);